export default "__VITE_ASSET__4bf01938__"